export enum DpEventName {
  Interaction = 'InteractionEvent',
  Duration = 'DurationEvent',
  Singular = 'SingularEvent',
}
